<template>
  <div class="modal fade" id="add_plant_batch" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div class="block-header bg-info bg-city-light">
            <h3 class="block-title"><i class="fa fa-cannabis"></i> Add Plant Batch</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close" @click.prevent="clearData()">
                <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{errorMsg}}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <div class="form-group required">
              <label class="control-label">Plant Batch Name</label>
              <input type="text" v-model="batchName" name="batch_name" v-validate="'required'" data-vv-as="Plantbatch Name" class="form-control form-control-alt" placeholder="Enter Plantbatch Name">
              <p v-if="errors.has('batch_name')" class="errorMsg">{{ errors.first('batch_name') }}</p>
            </div>
            <div class="form-group required">
              <label class="control-label">Type</label>
              <select id="plant-batch-type" name="type" style="width: 100%;" class="form-control select2-dropdown" placeholder="Select Type..">
                <option></option>
                <option v-for="(type, index) in library.plantBatchTypes" :key="index" :bind:value="type">{{ type }}</option>
              </select>
              <p v-if="typeError" class="errorMsg">The Type field is required.</p>
            </div>
            <div class="form-group required">
              <label class="control-label">Strain</label>
              <select id="plant-batch-strain" style="width: 100%;" name="strain" class="form-control select2-dropdown" placeholder="Select Strain..">
                <option></option>
                <option v-for="(strain, index) in library.strains" :key="index" :bind:value="strain.Name">{{ strain.Name }}</option>
              </select>
              <p v-if="strainError" class="errorMsg">The Strain field is required.</p>
            </div>
            <div class="form-group">
              <label>Room</label>
              <select id="plant-batch-room" class="form-control select2-dropdown" style="width: 100%;" placeholder="Select Room..">
                <option></option>
                <option v-for="(room, index) in library.rooms" :key="index" :bind:value="room.Name">{{ room.Name }}</option>
              </select>
            </div>
            <div class="form-group required">
              <label class="control-label">Count</label>
              <input v-model="batchCount" type="number" min="1" onkeypress="return event.charCode >= 48" name="count" id="count" class="form-control form-control-alt" placeholder="Count">
              <p v-if="countError" class="errorMsg">The Count field is required and it should be positive number.</p>
            </div>
            <div class="form-group">
              <label>Actual Date</label>
              <input type="text" id="plant-batch-date" name="date" v-model="date" class="form-control form-control-alt datepicker">
            </div>
          </div>
          <div class="block-content block-content-full text-right border-top button-loader">
            <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData()">Close</button>
            <button type="button" class="btn btn-sm btn-primary" @click="createPlantBatch()" :bind:disabled="showModalLoader">
              <div><i class="fa fa-save mr-1"></i><span>Save</span></div>
              <span class="modal-loader" v-if="showModalLoader">
                <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { mapState } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import $ from 'jquery';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';
Vue.use(VeeValidate, VueSpinners);

export default {
  name: 'AddPlantBatch',
  data() {
    return {
      batchName: '',
      batchType: '',
      batchCount: 1,
      batchStrain: '',
      batchRoom: '',
      date: new Date().toJSON().slice(0,10),
      types: [],
      strainError: false,
      typeError: false,
      showModalLoader: false,
      countError: false
    };
  },
  computed: {
    ...mapState({
      library: state => state.library
    })
  },
  mounted() {
    let vm = this;
    $('.datepicker').datepicker({ format: 'yyyy-mm-dd', autoclose:true });
    $('#plant-batch-strain').on('change', function() {
      vm.strainError = false; vm.batchStrain = $(this).val();
    });
    $('#plant-batch-type').on('change', function() {
      vm.typeError = false; vm.batchType = $(this).val();
    });
    $('#plant-batch-date').change(function() { vm.date = $(this).val(); });
    $('#count').keyup(function() {
      if($(this).val() > 0 && $(this).val() % 1 === 0) {
        vm.countError = false;
      } else {
        vm.countError = true;
      }
    });
  },
  components: {
    HashLoader  
  },
  methods: {
    clearData() {
      this.batchName = '';
      this.batchType = '';
      this.batchCount = 1;
      this.batchStrain = '';
      this.batchRoom = '';
      this.countError = false;
      this.strainError = false;
      this.date = new Date().toJSON().slice(0,10);
      $('.select2-dropdown').val(null).trigger('change');
      $('.datepicker').datepicker('update', this.date);
      this.$validator.reset();
    },
    createPlantBatch() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (vm.validate() && valid) {
          vm.showModalLoader = true;
          vm.errorMsg = '';
          helper.sendPostRequest('/plantbatches/createplantings', {
            'Name': vm.batchName,
            'Type': vm.batchType,
            'Count': vm.batchCount,
            'Strain': vm.batchStrain,
            'Room': vm.batchRoom,
            'ActualDate': vm.date
          }).then((data) => {
            if (data.status === 'success') {
              vm.$emit('loadPlantBatch', true);
              jQuery('#add_plant_batch').modal('hide');
              vm.showModalLoader = false;
              vm.clearData();
              vm.$emit('showSuccessMsg', data.message);
            } else {
              vm.errorMsg = data.message;
              vm.showModalLoader = false;
            }
          });
        }
      });
    },
    validate() {
      this.strainError = false;
      this.typeError = false;
      if (this.batchStrain === '') {
        this.strainError = true;
      }
      if (this.batchType === '') {
        this.typeError = true;
      }
      if (this.batchCount <= 0 || this.batchCount % 1 !== 0) {
        this.countError = true;
      }
      if (this.typeError || this.strainError || this.countError) {
        return false;
      }
      return true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// source/components/modals/AddPlantBatch.vue